export default __webpack_public_path__ + "static/media/tutord-logo-white.f232013b.svg";